import { Dispatch } from '../../../../../types/actions';
import { SnackbarVariant, ISnackbarControlModel } from '../../store/types';
import { addUpdateSnackbarWithBubble } from '../addUpdateSnackbarWithBubble/addUpdateSnackbarWithBubble';
import { SNACKBAR_BUTTON_CLOSE, SNACKBAR_BUTTON_CONTACT } from '../constants';
import { getDefaultActionEvent } from '../helpers/getDefaultActionEvent';
import { ISnackbarErrorPrompt } from './types';

export const snackbarErrorContactUs = (
    options: ISnackbarErrorPrompt
) => {
    return (dispatch: Dispatch) => {
        const buttons: ISnackbarControlModel[] = [
            {
                onClick: () => dispatch(getDefaultActionEvent(options.id, options.actionCancel)),
                text: SNACKBAR_BUTTON_CLOSE
            },
            {
                onClick: () => dispatch(getDefaultActionEvent(options.id, options.actionApply)),
                isPrimary: true,
                text: SNACKBAR_BUTTON_CONTACT
            }
        ];
        dispatch(addUpdateSnackbarWithBubble({
            id: options.id,
            buttons,
            text: options.text,
            title: options.title,
            variant: SnackbarVariant.ERROR
        }));
    }
};
